module.exports = __webpack_public_path__ + "static/media/tsc.be0ddd56.jpeg";